module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"nav":{"home":"Home","features":"Features","source":"Source"}},"zh":{"nav":{"home":"主页","features":"特点","source":"源码"}}}')
  delete Component.options._Ctor
}
